import { ActionBlockButton } from "~/components/buttons/ActionBlockButton";
import type {
	MonthlyClosingCloseRequest,
	MonthlyClosingNonProjectPart,
	MonthlyClosingReopenRequest,
	MonthlyClosingStaffingPart,
} from "~/modules/timeTracking/api/monthlyClosing/monthlyClosingTypes.ts";
import { getStaffingLabel, nonProjectLabel } from "~/modules/timeTracking/components/closingLists/closingListTypes.ts";

type ActionProps = {
	onCloseRequest: (request: MonthlyClosingCloseRequest) => void;
	onReopenRequest: (request: MonthlyClosingReopenRequest) => void;
};

type StaffingProps = ActionProps & {
	projectName: string;
	staffing: MonthlyClosingStaffingPart;
};

type NonProjectProps = ActionProps & {
	nonProject: MonthlyClosingNonProjectPart;
};

export function StaffingActions(props: StaffingProps) {
	const { staffing } = props;
	if (!staffing.isClosed) {
		if (!staffing.close) return null;
		return (
			<ActionBlockButton block={staffing.close}
							   theme="none"
							   size="xs"
							   onClick={() => props.onCloseRequest({
								   scope: { scope: "staffings", staffingIds: [staffing.staffingId] },
								   label: getStaffingLabel(staffing, props.projectName),
							   })}>
				Schließen
			</ActionBlockButton>
		);
	}
	if (!staffing.reopen) return null;
	return (
		<ActionBlockButton block={staffing.reopen}
						   theme="none"
						   size="xs"
						   onClick={() => props.onReopenRequest({
							   part: { part: "staffing", staffingId: staffing.staffingId },
							   label: getStaffingLabel(staffing, props.projectName),
						   })}>
			Wieder öffnen
		</ActionBlockButton>
	);
}

export function NonProjectActions(props: NonProjectProps) {
	if (!props.nonProject.isClosed) {
		if (!props.nonProject.close) return null;
		return (
			<ActionBlockButton block={props.nonProject.close}
							   theme="none"
							   size="xs"
							   onClick={() => props.onCloseRequest({ scope: { scope: "nonProject" }, label: nonProjectLabel })}>
				Schließen
			</ActionBlockButton>
		);
	}
	if (!props.nonProject.reopen) return null;
	return (
		<ActionBlockButton block={props.nonProject.reopen}
						   theme="none"
						   size="xs"
						   onClick={() => props.onReopenRequest({ part: { part: "nonProject" }, label: nonProjectLabel })}>
			Wieder öffnen
		</ActionBlockButton>
	);
}
